import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import Radio from 'components/Form/RadioButton'
import Button from 'components/Button'

export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
`

export const PublishContentFlex = styled(Flex)`
  padding-bottom: 20px;
`

export const FlexWrap = styled(Flex)`
  gap: 15px;
  margin-right: 10px;
`
export const RadioGroups = styled(RadioGroup)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`
export const Radios = styled(Radio)`
  border: none !important;
  font-weight: ${FONT.FW_600} !important;
  font-size: ${FONT.F_SM} !important;
  color: ${COLORS.GREY_T_20} !important;
  padding: 15px 0 15px 0;
  margin: 0;
`
export const NoCollageFlex = styled(Flex)`
  flex-direction: column;
`
export const NoCollageSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
  padding: 10px 0;
  margin: 10px 0;
`
export const SelectClgDiv = styled.div`
  font-style: normal;
  cursor: pointer;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const ConfirmButton = styled(Button.Primary)`
  width: 95px;
  height: 38px;
  border-radius: 10px;
  padding: 9px 20px;
`
